
import utils from '@/utils';
import { defineComponent } from 'vue';
import api from '@/api/lostPassword';
import { IElForm } from '@/types/element';

export default defineComponent({
  data() {
    return {
      form: {
        mobile: '',
        code: '',
        password: '',
        confirmPassword: '',
      },
      countdown: 0,
      validateMobile: utils.validateMobile,
    };
  },
  methods: {
    apiSendSms() {
      api.sendSms(
        {
          mobile: this.form.mobile,
        },
        (res) => {
          if (!res.value) return;

          utils.notifySuccess('验证码发送成功，10分钟内有效');
          this.countdown = 60;
          const interval = setInterval(() => {
            this.countdown -= 1;
            if (this.countdown <= 0) {
              clearInterval(interval);
            }
          }, 1000);
        },
      );
    },

    apiSubmit() {
      api.submit(
        {
          mobile: this.form.mobile,
          code: this.form.code,
          password: this.form.password,
        },
        (res) => {
          if (!res.value) return;

          utils.alertSuccess(
            {
              title: '恭喜，密码重置成功',
              button: '进入登录页',
            },
            () => {
              utils.pageOpen('/login');
            },
          );
        },
      );
    },

    isMobile(value: string) {
      return utils.isMobile(value);
    },

    btnSendSmsClick() {
      if (this.countdown > 0) return;
      if (!this.form.mobile) {
        utils.notifyError('手机号码不能为空');
        return;
      }
      if (!this.isMobile(this.form.mobile)) {
        utils.notifyError('请输入有效的手机号码');
        return;
      }

      this.apiSendSms();
    },

    btnLoginClick() {
      utils.pageOpen('/login');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },

    validatePass(rule: unknown, value: string, callback: (error?: Error) => void) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
  },
  mounted() {
    utils.loading(false);
  },
});
